"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResult = exports.SearchResultsDocumentList = exports.SearchResultDocument = exports.DownloadUrls = exports.Spell = exports.Image = exports.DataService = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var json2typescript_1 = require("json2typescript");
var lists_1 = require("src/lists");
var search_1 = require("src/search");
var String_utils_1 = require("src/String.utils");
var taxonomy_1 = require("src/taxonomy");
var FilterableDataService_1 = require("Views/Partials/Components/FilterableList/FilterableDataService");
var Tile_1 = require("Views/Partials/Components/Tile");
var SearchResultsService_1 = require("./SearchResultsService");
var DataService = /** @class */ (function (_super) {
    tslib_1.__extends(DataService, _super);
    function DataService(config) {
        var _this = _super.call(this, config) || this;
        _this.dateFormat = 'LL';
        _this.filterDocumentsAttribute = function (items) {
            return items.map(function (item) {
                if (item.type !== search_1.FullTextSearcherTypes.Products) {
                    return item;
                }
                if (!item.attributes) {
                    return item;
                }
                var toDeleteAttributeKeys = [];
                Object.keys(item.attributes).forEach(function (attributeKey) {
                    if (attributeKey.indexOf(' 65') > -1 &&
                        document.documentElement.lang.toLocaleLowerCase() !== 'en-us') {
                        toDeleteAttributeKeys.push(attributeKey);
                    }
                });
                toDeleteAttributeKeys.forEach(function (toDeleteAttributeKey) {
                    delete item.attributes[toDeleteAttributeKey];
                });
                return item;
            });
        };
        _this.applyCustomLogicToDocumentItem = function (documentItem, source) {
            // Expire or LastMod
            var isItemApproval = source.assetType && source.assetType === 'approval';
            if (isItemApproval) {
                documentItem.expireDate = source.expireDate
                    ? app_1.DateService.formatDate(source.expireDate, _this.dateFormat)
                    : '';
            }
            else {
                documentItem.lastModifiedDate = app_1.DateService.formatDate(source.lastModifiedDate, _this.dateFormat);
            }
            // ValidFor - Global or Multiple
            if (source.globalCountry) {
                documentItem.isGlobal = source.globalCountry;
            }
            else {
                documentItem.validFor = (0, lists_1.sortAlphabetically)((0, lists_1.fromObjectToArray)(source.country));
            }
        };
        _this.tranformDrawingsDownloadUrl = function (source) {
            var drawingType = source.drawingType, fileName = source.fileName, fileSize = source.fileSize, fileType = source.fileType, lastModifiedDate = source.lastModifiedDate, url = source.url;
            return {
                name: fileName,
                type: (0, lists_1.getFirstOrDefault)(drawingType, ''),
                updatedDate: app_1.DateService.formatDate(lastModifiedDate, _this.dateFormat),
                fileType: fileType.replace('.', '').toUpperCase(),
                fileSize: (0, Tile_1.FormatBytes)(fileSize),
                url: url,
            };
        };
        // Get group filter information like type, sort order, ...
        _this.groupFilterTemplates = taxonomy_1.TaxonomyService.getGroupFilterTemplateByType(config.type);
        // Create Search Api instance with specific type
        _this.searchApi = new search_1.FullTextSearchApi({
            url: _this.config.searchUrl,
        });
        // Set up dayjs library with current language
        app_1.DateService.setLocale(config.culture);
        return _this;
    }
    Object.defineProperty(DataService.prototype, "dictionary", {
        get: function () {
            return this.config.dictionary;
        },
        enumerable: false,
        configurable: true
    });
    /////////////////////////////////////
    // EXTENDED METHODS FROM FilterableDataService
    /////////////////////////////////////
    DataService.prototype.buildSearchApiParams = function (params) {
        var result = {
            country: this.config.country,
            language: this.config.language,
            hits: this.getPageHits(params.pageSize),
            offset: this.getPageOffset(params.page, params.pageSize),
            pageSize: this.getPageHits(params.pageSize),
            query: params.query,
            isInitialSearch: params.isInitialSearch,
            sort: params.sort,
        };
        if (!params.filters || params.filters.length < 1) {
            return result;
        }
        var filterOptions = this.convertFilterToOptions(params.filters);
        result.types = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.TypeFilterAlias);
        // ALL RESULTS FILTERS PARAMS
        result.allSegment = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.AllSegmentFilterAlias);
        // PRODUCTS FILTERS PARAMS
        result.productsSegment = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.ProductsSegmentFilterAlias);
        // DOCUMENTATION FILTERS PARAMS
        result.documentationSegment = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationSegmentFilterAlias);
        result.documentationDocumentTypes = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias);
        result.documentationProductionSite = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DocumentationProductionSiteAlias);
        result.documentationApprovalTypes = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias);
        result.documentationLanguageTypes = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias);
        result.documentationHierarchy = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias);
        result.documentationProductHierarchy = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias);
        result.documentationArchived = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias);
        result.documentationProductGroup = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias);
        result.documentationAuthorityFilter = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias);
        result.documentationProductSeries = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias);
        result.documentationCountryFilter = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DocumentationCountryFilterAlias);
        // DOWNLOAD FILTERS PARAMS
        result.downloadSegment = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DownloadSegmentFilterAlias);
        result.downloadSoftwareType = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias);
        result.downloadSoftwareCharacteristic = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias);
        result.downloadProductGroup = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias);
        result.downloadProductSeries = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias);
        // CAREERS FILTERS PARAMS
        result.careersCountryFilter = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.CareersCountryFilterAlias);
        result.careersLocation = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.CareersLocationFilterAlias);
        result.careersJobArea = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.CareersJobAreaFilterAlias);
        result.careersExperienceLevel = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.CareersExperienceLevelFilterAlias);
        // COURSE FILTERS PARAMS
        result.courseSegment = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.CourseSegmentFilterAlias);
        result.courseLearningEventType = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.CourseLearningEventTypeFilterAlias);
        result.courseDeliveryTypes = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias);
        result.courseLanguageTypes = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.CourseLanguageFilterAlias);
        result.courseHierarchy = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.CourseHierarchyFilterAlias);
        // DRAWINGS FILTERS PARAMS
        result.drawingsSegment = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias);
        result.drawingsDrawingTypes = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias);
        result.drawingsLanguageTypes = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias);
        result.drawingsArchived = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias);
        result.drawingsProductGroup = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias);
        result.drawingsProductSeries = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias);
        result.drawingsProductHierarchy = this.getFirstOrDefaultValue(filterOptions, search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias);
        this.addDeprecatedParams(result, filterOptions);
        return result;
    };
    // DEPRECATED FILTERS PARAMS
    //
    DataService.prototype.addDeprecatedParams = function (result, filterOptions) {
        result.documentTypes = this.getOptionValuesByName(filterOptions, search_1.DeprecatedFullTextSearchFilters.DocumentTypeFilterAlias);
        result.languageTypes = this.getOptionValuesByName(filterOptions, search_1.DeprecatedFullTextSearchFilters.LanguageFilterAlias);
        result.segment = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.SegmentFilterAlias);
        result.hierarchy = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.HierarchyFilterAlias);
        result.archived = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.ArchivedFilterAlias);
        result.documentationProductionSite = this.getOptionValuesByName(filterOptions, search_1.FullTextSearchFilters.DocumentationProductionSiteAlias);
        result.productGroup = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.ProductGroupFilterAlias);
        result.productType = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.ProductTypeFilterAlias);
        result.authorityFilter = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.AuthorityFilterAlias);
        result.productFamily = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.ProductFamilyFilterAlias);
        result.productSeries = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.ProductSeriesFilterAlias);
        result.location = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.LocationFilterAlias);
        result.jobArea = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.JobAreaFilterAlias);
        result.positionType = this.getFirstOrDefaultValue(filterOptions, search_1.DeprecatedFullTextSearchFilters.PositionTypeFilterAlias);
    };
    DataService.prototype.convertFilterToOptions = function (filters) {
        var _this = this;
        return filters.map(function (filterItem) {
            var _a = _this.splitFilterItem(filterItem), name = _a[0], value = _a[1];
            return {
                fieldName: name,
                fieldValue: decodeURIComponent(value),
            };
        });
    };
    DataService.prototype.buildTaxonomyApiParams = function (pageId) {
        var result = _super.prototype.buildTaxonomyApiParams.call(this, pageId);
        result.taxonomyAliases = taxonomy_1.TaxonomyService.convertToTaxonomyAliases(this.groupFilterTemplates).join(',');
        return result;
    };
    DataService.prototype.loadData = function (params, classReference) {
        if (classReference === void 0) { classReference = SearchResult; }
        // Set class reference to SearchResult to be able convert json to this class and make instance
        return _super.prototype.loadData.call(this, params, classReference);
    };
    DataService.prototype.isPropertyNull = function (key, value) {
        if (typeof key === 'undefined' || typeof value === 'undefined')
            return null;
    };
    DataService.prototype.processFailResult = function (error, args) {
        var _this = this;
        var deprecatedQueryError = 'com.findwise.search.exceptions.DeprecatedQuerySyntax';
        var errorName = error.responseData && error.responseData.data && error.responseData.data.cause;
        if (errorName && errorName === deprecatedQueryError) {
            var pageNumber = args.pageNumber, pageid = args.pageid, sort = args.sort, pageSize = args.pageSize, query = args.query;
            var urlObj = app_1.UrlService.GetObjectFromUrlString();
            var redirectQueryString = typeof error.responseData.data.message === 'string' ? error.responseData.data.message : '';
            var redirectUrlParams = redirectQueryString.split('&');
            var facetRegExp_1 = /facet(_[a-zA-Z])+/;
            var isFacetParam_1 = function (key) { return facetRegExp_1.test(key); };
            var getFilterName_1 = function (key) {
                return key
                    .split('_')
                    .filter(function (part) { return part !== 'facet' && part !== 'path'; })
                    .map(function (part, index) {
                    if (index === 0)
                        return part;
                    return (0, app_1.capitalizeFirstLetter)(part);
                })
                    .join('');
            };
            var resultingFiltersArr = redirectUrlParams
                .map(function (param) {
                var paramParts = param.split('=');
                var key = paramParts[0];
                var value = paramParts[1];
                _this.isPropertyNull(key, value);
                return isFacetParam_1(key) ? "".concat(getFilterName_1(key), ":").concat(value) : null;
            })
                .filter(function (f) { return f; });
            window.history.replaceState(null, null, app_1.UrlService.GetStringFromUrlObj(tslib_1.__assign(tslib_1.__assign({}, urlObj), { filter: resultingFiltersArr.join(',') })));
            var pageProps = {
                pageNumber: pageNumber,
                pageid: pageid,
            };
            return _super.prototype.getData.call(this, resultingFiltersArr, pageProps, sort, pageSize, query, null, true);
        }
        return _super.prototype.processFailResult.call(this, error, args);
    };
    DataService.prototype.processSuccessResult = function (data, taxonomies, searchApiParams) {
        var result = _super.prototype.processSuccessResult.call(this, data, taxonomies, searchApiParams);
        result.suggestions = (0, lists_1.getFirstOrDefault)(data.spell.suggestions, '');
        result.allResultsCount = this.getAllResultsDocumentsCount(data.facets);
        return result;
    };
    DataService.prototype.applyStatusOnResult = function (result) {
        result.status =
            result.items && result.items.length > 0
                ? this.createSuccessStatus()
                : this.createZeroResultStatus();
    };
    DataService.prototype.convertFacetsToFilters = function (facets, taxonomies, searchApiParams) {
        var _this = this;
        var result = [];
        // Remove facet prefix in id field and filter out facets: without Filters, without templates
        var filteredFacets = this.prepareFacets(facets, searchApiParams);
        // foreach facets and create filter group item
        filteredFacets.forEach(function (item) {
            // Get template by filter id
            var template = SearchResultsService_1.SearchResultsService.getGroupFilterTemplateByFilterId(item.id);
            // Create filter group item
            result.push(_this.createFilterGroupItem(item, template, searchApiParams));
        });
        return result;
    };
    DataService.prototype.convertDocumentsToTiles = function (documentList) {
        var _this = this;
        var result = [];
        if (documentList && documentList.documents) {
            result = this.filterDocumentsAttribute(documentList.documents.reduce(function (acc, currDocument) {
                try {
                    var tileListItem = _this.createTileListItem(currDocument);
                    acc.push(tileListItem);
                }
                catch (error) {
                    if (typeof appInsights !== 'undefined') {
                        appInsights.trackException(error, undefined, {
                            pageContext: 'Search Results',
                            pageUrl: window.location.href,
                            failingDocument: currDocument.id,
                            errorType: 'Search integration exception',
                        });
                    }
                    console.warn('Failing document:', currDocument);
                    console.warn('Stack trace: ', error);
                }
                return acc;
            }, []));
        }
        return result;
    };
    DataService.prototype.createTileListItem = function (source) {
        var generalData = _super.prototype.createTileListItem.call(this, source);
        generalData.type = source.type;
        generalData.title = (0, lists_1.getFirstOrDefault)(source.title, '');
        generalData.description = (0, lists_1.getFirstOrDefault)(source.description, '');
        generalData.softwareReleaseDate = source.softwareReleaseDate
            ? app_1.DateService.formatDate(source.softwareReleaseDate, this.dateFormat)
            : '';
        var specificData = this.createTileItemRegardingType(source);
        return tslib_1.__assign(tslib_1.__assign({}, generalData), specificData);
    };
    /////////////////////////////////////
    // PARSE FILTERS METHODS
    /////////////////////////////////////
    DataService.prototype.createFilterGroupItem = function (facet, template, searchApiParams) {
        var result = {};
        result.typeAlias = template.typeAlias;
        result.value = template.value;
        result.guiType = template.guiType;
        result.newSearchGuiType = template.newSearchGuiType;
        result.isCollapsed = template.isCollapsed;
        result.title = this.getGroupFilterTitle(template);
        result.label = template.labelProp && this.getValueFromDictionary(template.labelProp);
        result.placeholder = template.placeholder && this.getValueFromDictionary(template.placeholder);
        result.items = this.convertFacetFiltersToFilterItem(facet.filters, template, searchApiParams);
        result.unselectable = template.unselectable;
        result.isDisabled = template.isDisabled;
        result.isHidden = template.isHidden;
        result.isSearchable = template.isSearchable;
        return result;
    };
    DataService.prototype.getGroupFilterTitle = function (template) {
        var result = '';
        if (SearchResultsService_1.SearchResultsService.isSegmentFilterOfAnyType(template.type)) {
            var segmentGroup = taxonomy_1.TaxonomyService.getTaxonomyGroupByType(taxonomy_1.TaxonomyTypeEnum.SegmentsTaxonomy, this.taxonomyApiResult);
            if (!segmentGroup) {
                throw new Error("Segment taxonomy can't be empty or null.");
            }
            result = segmentGroup.title;
        }
        else {
            result = this.getValueFromDictionary(template.titleProp);
        }
        return result;
    };
    DataService.prototype.convertFacetFiltersToFilterItem = function (filters, template, searchApiParams) {
        var _this = this;
        var taxonomyGroup = this.getTaxonomyGroupByFilterType(template.type);
        var preparedFilters = this.prepareFacetFilters(filters, template);
        var result = preparedFilters.map(function (filter) {
            return _this.createFilterItem(filter, template, taxonomyGroup, searchApiParams);
        });
        // Apply default sort by title if group template doesn't have items template with custom sort
        if (!template.filters) {
            result.sort((0, lists_1.getStringCompareFunction)('title'));
        }
        return result;
    };
    DataService.prototype.prepareFacetFilters = function (filters, template) {
        var result = filters.filter(function (filter) {
            var hasItemTemplate = SearchResultsService_1.SearchResultsService.hasGroupFilterItemTemplate(template, filter.queryValue);
            return !template.filters || hasItemTemplate;
        });
        // Apply custom sort order if group template has items template
        if (template.filters) {
            result.sort(function (a, b) {
                var aPriority = SearchResultsService_1.SearchResultsService.getGroupFilterItemTemplate(template, a.queryValue).priority;
                var bPriority = SearchResultsService_1.SearchResultsService.getGroupFilterItemTemplate(template, b.queryValue).priority;
                return aPriority - bPriority;
            });
        }
        return result;
    };
    DataService.prototype.createFilterItem = function (filter, groupTemplate, taxonomyGroup, _searchApiParams) {
        var result = {};
        var itemTemplate = SearchResultsService_1.SearchResultsService.getGroupFilterItemTemplate(groupTemplate, filter.queryValue);
        result.title = this.getTitleForFilterItem(filter, groupTemplate.type, taxonomyGroup, itemTemplate);
        result.value = this.getValueForFilterItem(filter, groupTemplate.type);
        result.selected = filter.selected;
        result.documentsCount = filter.count;
        return result;
    };
    DataService.prototype.getTitleForFilterItem = function (filter, filterType, taxonomyGroup, itemTemplate) {
        var result;
        // Set title for filter item
        if (taxonomyGroup) {
            result = this.translateItemTitle(taxonomyGroup, filter);
        }
        else if (filterType === search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias ||
            filterType === search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias) {
            result =
                filter.queryValue.indexOf('true') !== -1
                    ? this.dictionary.archivedFilter
                    : this.dictionary.publishedFilter;
        }
        else if (filterType === search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias) {
            result = filter.displayName.includes('@')
                ? filter.displayName.substring(filter.displayName.indexOf('@') + 1, filter.displayName.length)
                : filter.displayName || filter.queryValue;
        }
        else if (itemTemplate) {
            result = this.config[itemTemplate.labelProp];
        }
        else {
            result = filter.displayName || filter.queryValue;
        }
        return result || '';
    };
    DataService.prototype.getValueForFilterItem = function (filter, filterType) {
        // Set value for filter item
        var filterValue = filter.queryValue;
        if (filterValue) {
            filterValue = (0, search_1.encodeFilterValue)(filterType, filterValue);
        }
        return filterValue;
    };
    DataService.prototype.prepareFacets = function (facets, searchApiParams) {
        var type = (0, lists_1.getFirstOrDefault)(searchApiParams.types, 'default');
        // Remove facet prefix in id field and filter out facets: without Filters, without templates
        var result = facets
            .map(function (item) {
            return tslib_1.__assign(tslib_1.__assign({}, item), { id: (0, lists_1.removePrefix)(item.id, search_1.FACET_PREFIX) });
        })
            .filter(function (item) {
            return (item.filters &&
                Array.isArray(item.filters) &&
                SearchResultsService_1.SearchResultsService.hasGroupFilterTemplate(item.id));
        })
            .sort(function (a, b) {
            var aOrder = SearchResultsService_1.SearchResultsService.getFilterOrderByTypeFilterAndId(type, a.id);
            var bOrder = SearchResultsService_1.SearchResultsService.getFilterOrderByTypeFilterAndId(type, b.id);
            return aOrder - bOrder;
        });
        return this.applyCustomFilterLogic(result, searchApiParams);
    };
    DataService.prototype.applyCustomFilterLogic = function (facets, searchApiParams) {
        var type = (0, lists_1.getFirstOrDefault)(searchApiParams.types, '');
        var hasDocumentationTypeSelected = !!type && type === search_1.FullTextSearcherTypes.Documentation;
        var hasCourseTypeSelected = !!type && type === search_1.FullTextSearcherTypes.Course;
        var hasDownloadTypeSelected = !!type && type === search_1.FullTextSearcherTypes.Download;
        var hasDocumentationSegmentSelected = !!searchApiParams.documentationSegment;
        var hasCareersTypeSelected = !!type && type === search_1.FullTextSearcherTypes.Careers;
        var hasDrawingsSelected = !!type && type === search_1.FullTextSearcherTypes.Drawings;
        var hasDrawingsSegmentSelected = !!searchApiParams.drawingsSegment;
        var hasDownloadSegmentSelected = !!searchApiParams.downloadSegment;
        return facets.filter(function (item) {
            var result = false;
            var templateType = SearchResultsService_1.SearchResultsService.getGroupFilterTemplateByFilterId(item.id).type;
            if (templateType === search_1.FullTextSearchFilters.TypeFilterAlias ||
                SearchResultsService_1.SearchResultsService.isSegmentFilterOfAnyType(templateType)) {
                result = true;
            }
            else if (hasDownloadTypeSelected) {
                result =
                    hasDownloadSegmentSelected ||
                        templateType === search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias;
            }
            else if (hasDocumentationTypeSelected) {
                result =
                    hasDocumentationSegmentSelected ||
                        templateType === search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DocumentationCountryFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DocumentationProductionSiteAlias;
            }
            else if (hasDrawingsSelected) {
                result =
                    hasDrawingsSegmentSelected ||
                        templateType === search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias ||
                        templateType === search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias;
            }
            else if (hasCareersTypeSelected || hasCourseTypeSelected) {
                result = true;
            }
            return result;
        });
    };
    /////////////////////////////////////
    // PARSE TILE METHODS
    /////////////////////////////////////
    DataService.prototype.createTileItemRegardingType = function (source) {
        switch (source.type) {
            case search_1.FullTextSearcherTypes.Products:
                return this.createProductsItem(source);
            case search_1.FullTextSearcherTypes.Documentation:
                return this.createDocumentationItem(source);
            case search_1.FullTextSearcherTypes.Drawings:
                return this.createDocumentationItem(source);
            case search_1.FullTextSearcherTypes.Careers:
                return this.createCareerItem(source);
            case search_1.FullTextSearcherTypes.Course:
                return this.createCourseItem(source);
            case search_1.FullTextSearcherTypes.Download:
            case null:
            case undefined:
                return this.createUmbracoItem(source);
            default:
                return this.createOtherItem(source);
        }
    };
    DataService.prototype.createCourseItem = function (source) {
        var result = {};
        result.images = source.imagesArr;
        result.imageAltText = source.imageAltText;
        result.segments = this.translateSegments(source.segment);
        result.title = (0, lists_1.getFirstOrDefault)(source.title, '') || "".concat(source.type, " ").concat(source.id);
        result.link = { url: source.url, newWindow: true };
        result.deliveryTypes = source.deliveryTypes;
        result.learningType = source.learningType;
        result._click = source._click;
        if (source.description) {
            result.description = (0, String_utils_1.processCourseDescription)(source.description[0]);
        }
        return result;
    };
    DataService.prototype.createDocumentationItem = function (source) {
        var _this = this;
        var result = {};
        if (source.mainLanguage) {
            result.language = (0, lists_1.fromObjectToArray)(source.mainLanguage);
        }
        else if (source.globalLanguage) {
            // Setting an array with two entries to show multi language message.
            result.language = Array(2);
        }
        else {
            throw new Error('Documentation item is missing mainLanguage and globalLanguage fields');
        }
        result.fileType = source.fileType;
        result.fileSize = source.fileSize;
        result.link = { url: source.url };
        result.documentType = (0, lists_1.getFirstOrDefault)(source.documentType, '');
        result.drawingType = (0, lists_1.getFirstOrDefault)(source.drawingType, '');
        result.archived = source.archived;
        result.segments = this.translateSegments(source.segment);
        result._click = source._click;
        this.applyCustomLogicToDocumentItem(result, source);
        if (source.downloadUrls && source.downloadUrls.length) {
            result.downloadUrls = source.downloadUrls.map(function (item) { return _this.tranformDrawingsDownloadUrl(item); });
            result.link = { url: '' };
            result.images = this.convertURLToHttps(source.imagesArr);
        }
        return result;
    };
    DataService.prototype.createCareerItem = function (source) {
        var result = {};
        result.location = (0, search_1.transformLocationParam)(source.location);
        result.date = app_1.DateService.formatDate(source.lastModifiedDate, this.dateFormat);
        result.link = { url: source.url, newWindow: true };
        result._click = source._click;
        return result;
    };
    DataService.prototype.createProductsItem = function (source) {
        var productPageType = source.pageType
            ? Tile_1.TileTypeFromString[(0, app_1.capitalizeFirstLetter)(source.pageType)]
            : source.pageType;
        var hasHybrisDataSource = source.dataSource === 'hybris';
        var isExternalLink = productPageType === Tile_1.TileTypeEnum.ProductExternalContent || hasHybrisDataSource;
        var result = {};
        result.codeNumber = (0, lists_1.getFirstOrDefault)(source.codeNumbers, '');
        result.attributes = source.attributes;
        // Change to result.images = source.imagesArr; after image http issue is solved
        result.images = this.convertURLToHttps(source.imagesArr);
        result.imageAltText = source.imageAltText;
        result.link = { url: source.externalUrl || source.url, newWindow: isExternalLink };
        result.segments = this.translateSegments(source.segment);
        result.pageType = source.pageType;
        result.dataSource = source.dataSource;
        result.isInformationObject = source.informationObject;
        result.isExternalLink = isExternalLink;
        result._click = source._click;
        if (source.storeUrl) {
            result.storeLink = { url: source.storeUrl, newWindow: true };
        }
        if (source.documentUrl) {
            result.documentsLink = { url: source.documentUrl, newWindow: false };
        }
        return result;
    };
    DataService.prototype.createUmbracoItem = function (source) {
        switch (source.pageType) {
            case search_1.FullTextSearcherTypes.Product:
                return this.createUmbracoInformationItem(source);
            case search_1.FullTextSearcherTypes.ProductExternal:
            case search_1.FullTextSearcherTypes.ProductCategory:
            case search_1.FullTextSearcherTypes.ProductSubCategory:
            case search_1.FullTextSearcherTypes.DownloadPage:
            case search_1.FullTextSearcherTypes.Event:
            case search_1.FullTextSearcherTypes.EventExternal:
            case search_1.FullTextSearcherTypes.Article:
                return this.createUmbracoTileItem(source);
            default:
                return this.createOtherItem(source);
        }
    };
    DataService.prototype.createUmbracoTileItem = function (source) {
        var result = {};
        result.pageType = source.pageType;
        result.image = (0, lists_1.getFirstOrDefault)(source.imagesArr, '');
        result.imageAltText = source.imageAltText;
        result.isExternalLink = !!source.externalUrl;
        result.lastModifiedDate = source.lastModifiedDate
            ? app_1.DateService.formatDate(source.lastModifiedDate, this.dateFormat)
            : '';
        result.softwareReleaseDate = source.softwareReleaseDate
            ? app_1.DateService.formatDate(source.softwareReleaseDate, this.dateFormat)
            : '';
        var properStartDate = source.start_date || source.startDate;
        result.startDate = properStartDate
            ? app_1.DateService.formatDate(properStartDate, this.dateFormat)
            : '';
        result.link = {
            newWindow: result.isExternalLink,
            url: result.isExternalLink ? source.externalUrl : source.url,
        };
        result.segments = this.translateSegments(source.segment);
        result.softwareTypes = this.translateDownloadTypes(source.softwareType);
        result._click = source._click;
        return result;
    };
    DataService.prototype.createUmbracoInformationItem = function (source) {
        var result = this.createUmbracoTileItem(source);
        result.isInformationObject = source.informationObject;
        if (source.storeUrl) {
            result.storeLink = { url: source.storeUrl, newWindow: true };
        }
        if (source.documentUrl) {
            result.documentsLink = { url: source.documentUrl, newWindow: false };
        }
        return result;
    };
    DataService.prototype.createOtherItem = function (source) {
        var result = {};
        result.pageType = source.pageType;
        result.link = { url: source.url };
        result._click = source._click;
        if (source.assetType === 'software') {
            result.assetType = source.assetType;
            result.softwareTypes = this.translateDownloadTypes(source.softwareType);
            result.fileSize = source.fileSize;
            result.fileType = source.fileType.toLowerCase();
            result.segments = this.translateSegments(source.segment);
            result.lastModifiedDate = source.lastModifiedDate
                ? app_1.DateService.formatDate(source.lastModifiedDate, this.dateFormat)
                : '';
            result.softwareCharacteristic = (0, lists_1.getFirstOrDefault)(source.softwareCharacteristic, '');
            result.softwareVersion = source.softwareVersion;
        }
        return result;
    };
    /////////////////////////////////////
    // OTHER METHODS
    /////////////////////////////////////
    DataService.prototype.getOptionValuesByName = function (filterOptions, filterName) {
        var result = filterOptions
            .filter(function (item) {
            return (0, String_utils_1.equalIgnoreCase)(item.fieldName, filterName);
        })
            .map(function (item) { return item.fieldValue; });
        return result.length > 0 ? result : undefined;
    };
    DataService.prototype.getFirstOrDefaultValue = function (filterOptions, filterName) {
        var result = this.getOptionValuesByName(filterOptions, filterName);
        return (0, lists_1.getFirstOrDefault)(result, undefined);
    };
    DataService.prototype.translateSegments = function (tags) {
        var segmentGroup = taxonomy_1.TaxonomyService.getTaxonomyGroupByType(taxonomy_1.TaxonomyTypeEnum.SegmentsTaxonomy, this.taxonomyApiResult);
        return taxonomy_1.TaxonomyService.getTranslation(segmentGroup, tags);
    };
    DataService.prototype.translateDownloadTypes = function (tags) {
        var downloadGroup = taxonomy_1.TaxonomyService.getTaxonomyGroupByType(taxonomy_1.TaxonomyTypeEnum.DownloadTypeTaxonomy, this.taxonomyApiResult);
        return taxonomy_1.TaxonomyService.getTranslation(downloadGroup, tags);
    };
    DataService.prototype.translateItemTitle = function (taxonomyGroup, filter) {
        var taxonomyItem = taxonomy_1.TaxonomyService.getTaxonomyItemByValue(taxonomyGroup, filter.queryValue);
        return taxonomyItem ? taxonomyItem.title : filter.displayName;
    };
    DataService.prototype.getTaxonomyGroupByFilterType = function (filterType) {
        var result = null;
        if (SearchResultsService_1.SearchResultsService.isSegmentFilterOfAnyType(filterType)) {
            result = taxonomy_1.TaxonomyService.getTaxonomyGroupByType(taxonomy_1.TaxonomyTypeEnum.SegmentsTaxonomy, this.taxonomyApiResult);
        }
        else if (filterType === search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias) {
            result = taxonomy_1.TaxonomyService.getTaxonomyGroupByType(taxonomy_1.TaxonomyTypeEnum.DownloadTypeTaxonomy, this.taxonomyApiResult);
        }
        return result;
    };
    DataService.prototype.splitFilterItem = function (filterItem) {
        var colonPosition = filterItem.indexOf(':');
        return [filterItem.slice(0, colonPosition), filterItem.slice(colonPosition + 1)];
    };
    DataService.prototype.getAllResultsDocumentsCount = function (facets) {
        if (!facets || facets.length === 0)
            return null;
        return facets.reduce(function (result, facet) {
            if (facet.id === 'facet_type' && facet.filters) {
                var allResultsTypeFilter = facet.filters.filter(function (filter) { return filter.queryValue === search_1.FullTextSearcherTypes.All; })[0];
                result = allResultsTypeFilter ? allResultsTypeFilter.count : null;
            }
            return result;
        }, null);
    };
    // Method must be removed after fixing problem with images having http protocol
    DataService.prototype.convertURLToHttps = function (urls) {
        if (!Array.isArray(urls))
            return urls;
        var httpRegExp = /^http:/;
        return urls.map(function (url) { return (httpRegExp.test(url) ? url.replace(httpRegExp, 'https:') : url); });
    };
    return DataService;
}(FilterableDataService_1.FilterableDataService));
exports.DataService = DataService;
/* tslint:disable */
var Image = /** @class */ (function () {
    function Image() {
        this.preview = undefined;
        this.mimeType = undefined;
        this.id = undefined;
        this.url = undefined;
    }
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('preview', String),
        tslib_1.__metadata("design:type", String)
    ], Image.prototype, "preview", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('mimetype', String),
        tslib_1.__metadata("design:type", String)
    ], Image.prototype, "mimeType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('id', String),
        tslib_1.__metadata("design:type", String)
    ], Image.prototype, "id", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('url', String),
        tslib_1.__metadata("design:type", String)
    ], Image.prototype, "url", void 0);
    Image = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('Image')
    ], Image);
    return Image;
}());
exports.Image = Image;
var Spell = /** @class */ (function () {
    function Spell() {
        this.id = undefined;
        this.displayName = undefined;
        this.suggestions = undefined;
    }
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('id', String),
        tslib_1.__metadata("design:type", String)
    ], Spell.prototype, "id", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('displayName', String),
        tslib_1.__metadata("design:type", String)
    ], Spell.prototype, "displayName", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('suggestions', [String]),
        tslib_1.__metadata("design:type", Array)
    ], Spell.prototype, "suggestions", void 0);
    Spell = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('Spell')
    ], Spell);
    return Spell;
}());
exports.Spell = Spell;
var DownloadUrls = /** @class */ (function () {
    function DownloadUrls() {
        this.fileName = undefined;
        this.fileType = undefined;
        this.fileSize = undefined;
        this.lastModifiedDate = undefined;
        this.url = undefined;
        this.image = [];
        this.drawingType = [];
    }
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('filename', String, true),
        tslib_1.__metadata("design:type", String)
    ], DownloadUrls.prototype, "fileName", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('filetype', String, true),
        tslib_1.__metadata("design:type", String)
    ], DownloadUrls.prototype, "fileType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('filesize', Number, true),
        tslib_1.__metadata("design:type", String)
    ], DownloadUrls.prototype, "fileSize", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('lastmod', Number, true),
        tslib_1.__metadata("design:type", String)
    ], DownloadUrls.prototype, "lastModifiedDate", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('url', String, true),
        tslib_1.__metadata("design:type", String)
    ], DownloadUrls.prototype, "url", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('image', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], DownloadUrls.prototype, "image", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('drawing_type', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], DownloadUrls.prototype, "drawingType", void 0);
    DownloadUrls = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('DownloadUrls')
    ], DownloadUrls);
    return DownloadUrls;
}());
exports.DownloadUrls = DownloadUrls;
var SearchResultDocument = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultDocument, _super);
    function SearchResultDocument() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.archived = undefined;
        _this.country = undefined;
        _this.globalCountry = undefined;
        _this.globalLanguage = undefined;
        _this.codeNumbers = undefined;
        _this.documentUrl = undefined;
        _this.fileSize = undefined;
        _this.assetType = undefined;
        _this.fileType = undefined;
        _this.jobArea = undefined;
        _this.imagesArr = undefined;
        _this.images = undefined;
        _this.imageAltText = undefined;
        _this.informationObject = undefined;
        _this.lastModifiedDate = undefined;
        _this.learningType = undefined;
        _this.deliveryTypes = undefined;
        _this.start_date = undefined;
        _this.startDate = undefined;
        _this.expireDate = undefined;
        _this.mainLanguage = undefined;
        _this.pageType = undefined;
        _this.dataSource = undefined;
        _this.path = undefined;
        _this.productType = undefined;
        _this.positionType = undefined;
        _this.type = undefined;
        _this.storeUrl = undefined;
        _this.segment = undefined;
        _this.externalUrl = undefined;
        _this.downloadType = undefined;
        _this.downloadUrls = undefined;
        _this.drawingType = undefined;
        _this.softwareType = undefined;
        _this.softwareCharacteristic = undefined;
        _this.softwareVersion = undefined;
        _this.softwareReleaseDate = undefined;
        _this._url = undefined;
        _this._url_en = undefined;
        _this.sort = undefined;
        _this.title = undefined;
        _this.documentType = undefined;
        _this.description = undefined;
        _this.attributes = undefined;
        _this._click = undefined;
        return _this;
    }
    Object.defineProperty(SearchResultDocument.prototype, "url", {
        get: function () {
            return this._url_en || this._url || '';
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('archived', Boolean, true),
        tslib_1.__metadata("design:type", Boolean)
    ], SearchResultDocument.prototype, "archived", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('country', json2typescript_1.Any, true)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ,
        tslib_1.__metadata("design:type", Object)
    ], SearchResultDocument.prototype, "country", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('global_country', Boolean, true),
        tslib_1.__metadata("design:type", Boolean)
    ], SearchResultDocument.prototype, "globalCountry", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('global_language', Boolean, true),
        tslib_1.__metadata("design:type", Boolean)
    ], SearchResultDocument.prototype, "globalLanguage", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('codenumbers', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "codeNumbers", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('documentUrl', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "documentUrl", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('filesize', Number, true),
        tslib_1.__metadata("design:type", Number)
    ], SearchResultDocument.prototype, "fileSize", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('asset_type', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "assetType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('filetype', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "fileType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('job_area', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "jobArea", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('image', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "imagesArr", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('images', [Image], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "images", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('image_alt_text', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "imageAltText", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('informationObject', Boolean, true),
        tslib_1.__metadata("design:type", Boolean)
    ], SearchResultDocument.prototype, "informationObject", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('lastmod', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "lastModifiedDate", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('learning_type', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "learningType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('delivery_types', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "deliveryTypes", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('start_date', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "start_date", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('startDate', Number, true),
        tslib_1.__metadata("design:type", Number)
    ], SearchResultDocument.prototype, "startDate", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('expire_date', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "expireDate", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('mainLanguage', Object, true)
        // eslint-disable-next-line @typescript-eslint/ban-types
        ,
        tslib_1.__metadata("design:type", Object)
    ], SearchResultDocument.prototype, "mainLanguage", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('page_type', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "pageType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('dataSource', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "dataSource", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('path', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "path", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('product_type', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "productType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('position_type', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "positionType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('type', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "type", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('storeUrl', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "storeUrl", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('segment', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "segment", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('external_url', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "externalUrl", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('download_type', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "downloadType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('download_urls', [DownloadUrls], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "downloadUrls", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('drawing_type', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "drawingType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('software_type', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "softwareType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('software_characteristic', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "softwareCharacteristic", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('software_version', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "softwareVersion", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('software_release_date', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "softwareReleaseDate", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('url', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "_url", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('url_en', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "_url_en", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('sort', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultDocument.prototype, "sort", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('title', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "title", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('document_type', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "documentType", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('description', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultDocument.prototype, "description", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('attributes', Object, true)
        // eslint-disable-next-line @typescript-eslint/ban-types
        ,
        tslib_1.__metadata("design:type", Object)
    ], SearchResultDocument.prototype, "attributes", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('_click', Object, true)
        // eslint-disable-next-line @typescript-eslint/ban-types
        ,
        tslib_1.__metadata("design:type", Object)
    ], SearchResultDocument.prototype, "_click", void 0);
    SearchResultDocument = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('SearchResultDocument')
    ], SearchResultDocument);
    return SearchResultDocument;
}(search_1.DocumentBase));
exports.SearchResultDocument = SearchResultDocument;
var SearchResultsDocumentList = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultsDocumentList, _super);
    function SearchResultsDocumentList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.documents = undefined;
        return _this;
    }
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('documents', [SearchResultDocument]),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultsDocumentList.prototype, "documents", void 0);
    SearchResultsDocumentList = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('SearchResultsDocumentList')
    ], SearchResultsDocumentList);
    return SearchResultsDocumentList;
}(search_1.DocumentListBase));
exports.SearchResultsDocumentList = SearchResultsDocumentList;
var SearchResult = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResult, _super);
    function SearchResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.documentList = undefined;
        _this.spell = undefined;
        return _this;
    }
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('documentList', SearchResultsDocumentList),
        tslib_1.__metadata("design:type", SearchResultsDocumentList)
    ], SearchResult.prototype, "documentList", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('spell', Spell),
        tslib_1.__metadata("design:type", Spell)
    ], SearchResult.prototype, "spell", void 0);
    SearchResult = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('SearchResult')
    ], SearchResult);
    return SearchResult;
}(search_1.SearchResultBase));
exports.SearchResult = SearchResult;
/* tslint:enable */
